(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairBadgesController', PhysicalFairBadgesController);
    PhysicalFairBadgesController.$inject = ['$uibModal', 'CitiesByExpoService', 'PhysicalFairService', 'expos'];
    function PhysicalFairBadgesController($uibModal, CitiesByExpoService, PhysicalFairService, expos) {
        var vm = this;

        vm.flag                  = false;
        vm.commentsResult        = [];
        vm.expoSelected          = '';
        vm.cities                = [{expos_locations_id: -1, city_name: '--- All ---'}];
        vm.i                     = -1;
        vm.selectCitiesByExpo    = selectCitiesByExpo;
        vm.getByFilter           = getByFilter;
        vm.citySelected          = -1;
        vm.citySelectedCSV       = '';
        vm.expoSelectedCSV       = '';

        /*PAGINATION*/
        vm.pageChanged           = pageChanged;
        vm.setPage               = setPage;
        vm.to                    = [];
        vm.totalItems            = [];
        vm.currentPage           = null;
        vm.itemsPerPage          = [];
        vm.page                  = 1;
        vm.downloadCSV           = downloadCSV;

        function activate() {
            vm.expos = expos;
        }

        function selectCitiesByExpo () {
            CitiesByExpoService.getCities(vm.expoSelected).then(function(response){
                vm.cities = response.data;
                vm.cities.unshift({expos_locations_id: -1, city_name: '--- All ---'});
                vm.citySelected = -1;
            }).catch(function(err) {
            });
        }

        function getByFilter() {
            vm.flag = false;
            vm.query = {};
            if (vm.expoSelected !== '') {
                vm.query['expo_id'] = vm.expoSelected;
            }
            if (vm.citySelected !== '' && vm.citySelected !== -1) {
                vm.query['location_id'] = vm.citySelected;
            }
            if (vm.page !== null) {
                vm.query['page'] = vm.page;
            }

            /* Load variables to CSV */
            vm.citySelectedCSV  = vm.citySelected;
            vm.expoSelectedCSV  = vm.expoSelected;
            PhysicalFairService.getByFilterBadges(vm.query).then(function(response){
                vm.exhibitors = response.data.data;
                vm.flag = true;
                if(vm.exhibitors.length == 0){
                    vm.noResultMessage = 'Sorry, no results were found!';
                    vm.flag = false;
                } else {
                    vm.noResultMessage = '';
                    vm.flag = true;
                }

                vm.totalItems = response.data.total;
                vm.to         = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
            }).catch(function(err){
            });
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function downloadCSV () {
            let query = {};
            if (vm.expoSelected !== '' && vm.expoSelected !== -1) {
                query['expo_id'] = vm.expoSelected;
            }
            if (vm.citySelected !== '' && vm.citySelected !== -1) {
                query['location_id'] = vm.citySelected;
            }
            PhysicalFairService.downloadReportBadgesCSV(query).success(function(data, status, headers, config) {
                var anchor = document.createElement('a');
                anchor.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(data);
                anchor.target = '_blank';
                anchor.download = 'report_badges.csv';
                document.body.appendChild(anchor);
                anchor.click();
                $timeout(function () {
                    anchor.remove();
                }, 50);
            }).error(function(data, status, headers, config) {
                // handle error
            });
        }
        activate();
    }
})();